import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

const fallbackFonts = ['Open Sans', 'arial', 'sans-serif'];
const scandinavian = ['ScandinavianRegular', ...fallbackFonts].join(',');
const scandinavianBlack = ['scandinavianblack', ...fallbackFonts].join(',');

// SAS theme
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#000099', // B3
    },
    secondary: {
      main: '#006ee6', // B1
    },
    error: {
      main: '#e81e14',
    },
    background: {
      default: '#fff',
    },
    text: {
      primary: '#3f3d3a', // G5
      secondary: '#68645c', // G4
    },
  },
  typography: {
    fontFamily: scandinavian,
    button: {
      fontFamily: scandinavianBlack,
    },
    h6: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
    },
    h5: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
    },
    h4: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
    },
    h3: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
    },
    h2: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
    },
    h1: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
    },
  },
  /* overrides: {
    MuiPickersDay: {
      root: {
        fontSize: '12px',
      },
    },
  }, */
});

export default responsiveFontSizes(theme);
